import React, { useState, useEffect } from "react";

import axios from "axios";
import "./App.css";
import Daily from "./Daily.js";

export default function WeatherForecast(props) {
  let [loaded, setLoaded] = useState(false);
  let [weather, setWeather] = useState(null);

  useEffect(() => {
    setLoaded(false);
  }, [props.coord]);

  function findCoordinates(response) {
    setWeather(response.data.daily);
    setLoaded(true);
  }

  if (loaded) {
    console.log(weather);

    return (
      <div className="forecast-row" id="forecast">
        {weather.slice(0, 3).map(function (value, index) {
          return (
            <div className="forecast-item" key={index}>
              <Daily forecast={value} />
            </div>
          );
        })}
      </div>
    );
  } else {
    let key = "8c48afa47a9a9c24f3500c7039d50aaa";
    let lati = props.coord.lat;
    let longi = props.coord.lon;
    let url = `https://api.openweathermap.org/data/2.5/onecall?lat=${lati}&lon=${longi}&appid=${key}&units=metric`;
    axios.get(url).then(findCoordinates);
    return " ...";
  }
}
